import { SearchTermsContext } from "context/ViewContext/SearchTermsContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useSearchTerms = () => {
  return useProviderInitializedContext(SearchTermsContext);
};
